<div class="card" [style.background]="backgroundStyle">
  <div class="content-container">
    <div
      class="overview-section flex-1 d-flex fd-col ai-center"
    >
      <div
        class="feature-section d-flex fd-row fd-col--lt-sm jc-center ai-center"
        style="flex: 1 0 auto"
        *ngFor="let textRow of tileInstance.textRows; let odd = odd"
      >
        <div class="overview-box basis-100 order-1 order-2--xs">
          <p
            [style.color]="textRow.headingFontColor"
            [style.fontSize]="textRow.headingFontSize | pxSuffix"
          >
            {{ textRow.heading }}
          </p>
          <p
            class="feature-description"
            [style.color]="textRow.textFontColor"
            [style.fontSize]="textRow.textFontSize | pxSuffix"
          >
            {{ textRow.text }}
          </p>
          <button
            mat-stroked-button
            color="basic"
            [routerLink]="getRouteLink(linkButton.routeLink)"
            (click)="logRouteNavigation(linkButton.routeLink)"
            [style.color]="linkButton.buttonFontColor"
            [style.fontSize]="linkButton.buttonFontSize | pxSuffix"
            [style.backgroundColor]="linkButton.buttonBackgroundColor"
            *ngFor="let linkButton of textRow.linkButtons"
          >
            <mat-icon [style.fontSize]="linkButton.buttonFontSize | pxSuffix">{{
              linkButton.buttonIcon
            }}</mat-icon>
            <span>{{ linkButton.buttonText }}</span>
          </button>
        </div>

        <ng-container>
          <div
            class="overview-box basis-60"
            [style.order]="textRow.imgPosition === 'start' ? '0' : '1'"
          >
            <img [src]="getImgPath(textRow.img)" />
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
